module.exports = __webpack_public_path__ + "img/5_uk.1553c2c3.svg";